
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Label } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Label`}</h1>
<p>{`Usage`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Label } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<Label>Label text</Label>`} component={Label} mdxType="Playground">
  <Label mdxType="Label">Label text</Label>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;